import { DirectiveOptions } from "vue";

const isNumericKey = (event: KeyboardEvent): void => {
  if (!/^[0-9]+$/.test(event.key) && event.key != "Backspace" && event.key != "Delete" && event.key != "ArrowLeft" && event.key != "ArrowRight") {
    event.preventDefault();
  }
};

const directive: DirectiveOptions = {
  bind(el) {
    el.addEventListener("keydown", isNumericKey);
  },
  unbind(el) {
    el.removeEventListener("keydown", isNumericKey);
  }
};

export default directive;
